<template lang="pug">
  #game-profile-nav
    a.link(href="#summary")
      .icon
        img(:src="iconSrc")
    a.link(v-for="(value, name) in links" :href="`#${name}`")
      span(:style="linkStyles") {{ name }} 
      span(v-html="value")
</template>

<script>

export default {
  name: "GameProfileNav",
  props: {
    iconSrc: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      links: {
        controls: "&#x1F3AE;",
        resources: "&#x1F4C2;",
        goals: "&#x1F3AF;",
        successes: "&#x1F44C;",
        failures: "&#x1F44E;",
        bugs: "&#x1F41B;",
        ideas: "&#x1F4A1;",
        conclusions: "&#x1F531;"
      }
    }
  },
  computed: {
    linkStyles() {
      return {
        '--color': this.colors.muted,
        '--color-hover': this.colors.text
      }
    }
  }
}
</script>

<style lang="stylus">
#game-profile-nav
  box-sizing border-box
  display flex
  align-items center
  overflow-x scroll
  padding 0 sp2 s0
  height sp4 + s0
  width 100%
  > a.link
    display flex
    font-weight 600
    margin-right sp2
    text-decoration none
    &:last-of-type
      padding-right sp2
    &:hover
      > .icon > img
        opacity 1
      > span:first-of-type
        color var(--color-hover)
      > span:last-of-type
        opacity 1
    > span:first-of-type
      color var(--color)
      margin-right sm2
      text-transform capitalize
      transition all 0.2s ease-in-out
    > span:last-of-type
      opacity 0.6
      transition all 0.2s ease-in-out
  @media (min-width: 1280px)
    margin 0 auto
    overflow hidden
    max-width 1280px
    
</style>